module.exports = " <span> <ul v-if=\"data && data.length\" :class=\"[prefixCls + '-menu']\"> <casitem v-for=\"item in data\" :key=item :prefix-cls=prefixCls :data=item :tmp-item=tmpItem @click.stop=handleClickItem(item) @mouseenter.stop=handleHoverItem(item)></casitem> </ul><caspanel v-if=\"sublist && sublist.length\" :prefix-cls=prefixCls :data=sublist :disabled=disabled :trigger=trigger :change-on-select=changeOnSelect></caspanel> </span> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/standard/components/cascader/caspanel.vue
// module id = 294
// module chunks = 0